import { gql } from '@apollo/client';

export const AUDIT_LOGS_QUERY = gql`
  query AuditLogs($limit: Int, $offset: Int, $filters: AuditLogFilterInput) {
    auditLogs(limit: $limit, offset: $offset, filters: $filters) {
      items {
        id
        category
        categoryDisplay
        action
        actionDisplay
        severity
        title
        description
        targetType
        targetId
        targetName
        changes
        ipAddress
        userAgent
        requestPath
        requestMethod
        metadata
        createdAt
        userName
        userEmail
      }
      totalCount
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const AUDIT_LOG_QUERY = gql`
  query AuditLog($id: ID!) {
    auditLog(id: $id) {
      id
      category
      categoryDisplay
      action
      actionDisplay
      severity
      title
      description
      targetType
      targetId
      targetName
      changes
      ipAddress
      userAgent
      requestPath
      requestMethod
      metadata
      createdAt
      userName
      userEmail
    }
  }
`;

export const AUDIT_LOG_CATEGORIES_QUERY = gql`
  query AuditLogCategories {
    auditLogCategories
  }
`;

export const AUDIT_LOG_ACTIONS_QUERY = gql`
  query AuditLogActions {
    auditLogActions
  }
`;

export const AUDIT_LOG_STATS_QUERY = gql`
  query AuditLogStats {
    auditLogStats
  }
`;

export interface AuditLogItem {
  id: string;
  category: string;
  categoryDisplay: string;
  action: string;
  actionDisplay: string;
  severity: string;
  title: string;
  description: string;
  targetType: string;
  targetId: string;
  targetName: string;
  changes: string;
  ipAddress: string | null;
  userAgent: string;
  requestPath: string;
  requestMethod: string;
  metadata: string;
  createdAt: string;
  userName: string | null;
  userEmail: string | null;
}

export interface AuditLogConnection {
  items: AuditLogItem[];
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface AuditLogFilters {
  category?: string;
  action?: string;
  severity?: string;
  userId?: string;
  targetType?: string;
  targetId?: string;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
}

// Mutations for logging events from frontend
export const LOG_NAVIGATION_MUTATION = gql`
  mutation LogNavigation($input: LogNavigationInput!) {
    logNavigation(input: $input)
  }
`;

export const LOG_EVENT_MUTATION = gql`
  mutation LogEvent($input: LogEventInput!) {
    logEvent(input: $input)
  }
`;
